import { render } from "./BgLayerSwitcher.vue?vue&type=template&id=ba300c40"
import script from "./BgLayerSwitcher.vue?vue&type=script&lang=js"
export * from "./BgLayerSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__